module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$attrs.value && _vm.$attrs.value.length > 0) ? _c('div', {
    class: _vm.galleriaClass,
    style: (_vm.$attrs.containerStyle),
    attrs: {
      "id": _vm.id
    }
  }, [(_vm.$attrs.fullScreen) ? _c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    staticClass: "p-galleria-close p-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('maskHide')
      }
    }
  }, [_c('span', {
    staticClass: "p-galleria-close-icon pi pi-times"
  })]) : _vm._e(), _vm._v(" "), (_vm.$attrs.templates && _vm.$attrs.templates['header']) ? _c('div', {
    staticClass: "p-galleria-header"
  }, [_c('GalleriaItemSlot', {
    attrs: {
      "type": "header",
      "templates": _vm.$attrs.templates
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-galleria-content"
  }, [_c('GalleriaItem', {
    attrs: {
      "value": _vm.$attrs.value,
      "activeIndex": _vm.activeIndex,
      "circular": _vm.$attrs.circular,
      "templates": _vm.$attrs.templates,
      "showIndicators": _vm.$attrs.showIndicators,
      "changeItemOnIndicatorHover": _vm.$attrs.changeItemOnIndicatorHover,
      "showItemNavigators": _vm.$attrs.showItemNavigators,
      "autoPlay": _vm.$attrs.autoPlay,
      "slideShowActive": _vm.slideShowActive
    },
    on: {
      "update:activeIndex": function($event) {
        _vm.activeIndex = $event
      },
      "update:active-index": function($event) {
        _vm.activeIndex = $event
      },
      "update:slideShowActive": function($event) {
        _vm.slideShowActive = $event
      },
      "update:slide-show-active": function($event) {
        _vm.slideShowActive = $event
      },
      "startSlideShow": _vm.startSlideShow,
      "stopSlideShow": _vm.stopSlideShow
    }
  }), _vm._v(" "), (_vm.$attrs.showThumbnails) ? _c('GalleriaThumbnails', {
    attrs: {
      "containerId": _vm.id,
      "value": _vm.$attrs.value,
      "activeIndex": _vm.activeIndex,
      "templates": _vm.$attrs.templates,
      "numVisible": _vm.$attrs.numVisible,
      "responsiveOptions": _vm.$attrs.responsiveOptions,
      "circular": _vm.$attrs.circular,
      "isVertical": _vm.isVertical(),
      "contentHeight": _vm.$attrs.verticalThumbnailViewPortHeight,
      "showThumbnailNavigators": _vm.$attrs.showThumbnailNavigators,
      "slideShowActive": _vm.slideShowActive
    },
    on: {
      "update:activeIndex": function($event) {
        _vm.activeIndex = $event
      },
      "update:active-index": function($event) {
        _vm.activeIndex = $event
      },
      "update:slideShowActive": function($event) {
        _vm.slideShowActive = $event
      },
      "update:slide-show-active": function($event) {
        _vm.slideShowActive = $event
      },
      "stopSlideShow": _vm.stopSlideShow
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.$attrs.templates && _vm.$attrs.templates['footer']) ? _c('div', {
    staticClass: "p-galleria-footer"
  }, [_c('GalleriaItemSlot', {
    attrs: {
      "type": "footer",
      "templates": _vm.$attrs.templates
    }
  })], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40a4e088"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/galleria/GalleriaContent.vue
// module id = 2177
// module chunks = 0